<template>
  
    <content-header
        icona="fas fa-chalkboard-teacher"
        titolo="Corsi"
    ></content-header>

    <div class="card sn-card-contenuto">
        <div class="card-body">

           <!-- *** GRIGLIA CORSI *** -->
           <div class="card" v-if="mostraGrigliaCorsi">
                <div class="card-body">

                    <button type="button" class="btn btn-dark" @click="GetListCorsi()">
                        <i class="fas fa-sync"></i>&nbsp;
                    </button>&nbsp;
                    <button type="button" class="btn btn-success" @click="AttivaEditCorso">
                        <i class="fas fa-plus"></i>&nbsp;Nuovo Corso
                    </button>&nbsp;
                    <button type="button" class="btn btn-secondary" @click="EsportaListaCorsi">
                        <i class="fas fa-file-excel"></i>&nbsp;Esporta elenco
                    </button>
                    <br /><br />

                    <div class="d-flex justify-content-start">
                        <div class="form-group mx-2 " style="width:350px">
                            <label>Ricerca testuale</label>
                            <input type="text" class="form-control form-control-sm" placeholder="cerca per ..." v-model="reqGrigliaCorsi.Testuale" @keyup.enter="GetListCorsi" />
                        </div>
                        
                        <div class="from-group mx-2">
                            
                            <a class="btn btn-sm btn-dark" @click="AzzeraFiltri" style="margin-top:30px;">
                            <i class="fas fa-times"></i>&nbsp;Azzera
                            </a>&nbsp;
                            <a class="btn btn-sm btn-info" @click="GetListCorsi" style="margin-top:30px;" >
                            <i class="fas fa-search"></i>&nbsp;Cerca
                            </a>
                        </div>
                    </div>  
                    <div class="d-flex justify-content-start">
      

                    </div>
                    
                    
                    <br/>
                    <griglia-facile
                        :colonne-header="g_colonneHeader"
                        :colonne="g_colonne"
                        :colonneNoOrder="g_colonneNoOrder"
                        :colonneAlign="g_colonneAlign"
                        :comandi="g_comandi"
                        :mostraPager="true"
                        classi-table="table-sm table-hover table-custom"
                        :dati="dtCorsi"
                        :queryLength="g_queryLength"
                        :currentPage="g_currentPage"
                        
                        @Seleziona="SelectCorso"
                        @Cancella="DelElemCorsi"
                        @Ordina="OrdinaGriglia"
                        
                        @CambiaElementi="CambiaElementi"
                        @Precedente="PaginaPrecendente"
                        @Successiva="PaginaSuccessiva"
                        @CambiaPagina="CambiaPagina"
                       

                        fontawesome="standard"

                        ></griglia-facile>

                </div>
            </div>

            <!-- *** EDIT CORSO *** -->
            <div class="card" v-if="mostraEditCorso">
            <div class="card-header">
                <button type="button" class="btn btn-sm btn-outline-dark" @click="AttivaGriglia">Chiudi</button>&nbsp;
                <button type="button" class="btn btn-sm btn-outline-dark" @click="SalvaCorso(true)">Salva</button>&nbsp;
                <button type="button" class="btn btn-sm btn-outline-dark" @click="SalvaCorso(false)">Salva e Chiudi</button>
            </div>
            <div class="card-body">
                

                <form autocomplete="off">

                <messaggio-standard 
                    :mostraMessaggio="mostraMessaggio"
                    :alertClass="alertClass"
                    :alertIcon="alertIcon"
                    :alertIconSpin="alertIconSpin"
                    :alertMessaggio="alertMessaggio"
                    fontawesome="standard"
                    ></messaggio-standard>
                    
                <div class="row rigaSezioneForm">
                    <div class="col-md">
                        <i class="fas fa-info text-primary"></i>&nbsp;Dati generali
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-2 mb-3">
                        <label class="form-label">Tipo Corso</label>
                        <select v-model="oCorso.cor_idTipo" class="form-select">
                            <option value="1">Profitto</option>
                            <option value="2">Partecipazione</option>
                        </select>
                    </div>
                    <!-- <div class="col-md mb-3">
                        <label class="form-label">Cliente Corso</label>
                        <select v-model="oCorso.cor_idCli" class="form-select">
                            <option v-for="c, i in dtClienti" :key="i" :value="c.ana_id">{{c.ana_ragioneSociale}} [{{ c.ana_piva }}]</option>
                        </select>
                    </div> -->
                    <div class="col-md mb-3">
                        <label class="form-label">Stato Corso</label>
                        <select v-model="oCorso.cor_stato" class="form-select">
                            <option v-for="s, i in dtCorsiStati" :key="i" :value="s.cst_id">{{s.cst_descrizione}}</option>
                        </select>
                    </div>
                </div>

                <div class="row">
                    <div class="col-md mb-3">
                        <label class="form-label">Codice Corso</label>
                        <input type="text" v-model="oCorso.cor_codice" class="form-control" placeholder="Inserisci il codice del corso">
                    </div>
                    <div class="col-md mb-3">
                        <label class="form-label">Data Inizio Corso</label>
                        <input type="date" v-model="oCorso.cor_dta_inizio" class="form-control">
                    </div>

                    <div class="col-md mb-3">
                        <label class="form-label">Data Fine Corso</label>
                        <input type="date" v-model="oCorso.cor_dta_fine" class="form-control">
                    </div>

                </div>
                

                <div class="mb-3">
                    <label class="form-label">Titolo Corso</label>
                    <input type="text" v-model="oCorso.cor_titolo" class="form-control" placeholder="Inserisci il titolo del corso">
                </div>

                <div class="mb-3">
                    <label class="form-label">Descrizione Corso</label>
                    <textarea v-model="oCorso.cor_descrizione" class="form-control" rows="3" placeholder="Inserisci la descrizione del corso"></textarea>
                </div>

                <div class="row">
                    <div class="col-md mb-3">
                        <label class="form-label">Docente</label>
                        <select v-model="oCorso.cor_idDoc" class="form-control">
                            <option value="-1">Scegli docente...</option>
                            <option v-for="d, i in dtDocenti" :key="i" :value="d.doc_id">{{ d.doc_cognome }} {{ d.doc_nome }}</option>
                        </select>
                    </div>

                    <div class="col-md mb-3">
                        <label class="form-label">Numero Partecipanti minimo</label>
                        <input type="number" v-model="oCorso.cor_npartecipanti_min" class="form-control" placeholder="Inserisci il numero di partecipanti minimo">
                    </div>

                    <div class="col-md mb-3">
                        <label class="form-label">Numero Partecipanti massimo</label>
                        <input type="number" v-model="oCorso.cor_npartecipanti_max" class="form-control" placeholder="Inserisci il numero di partecipanti massimo">
                    </div>
                </div>

                <div class="row rigaSezioneForm">
                    <div class="col-md">
                        <i class="fas fa-graduation-cap text-primary"></i>&nbsp;Valutazione
                    </div>
                </div>

                <div class="row">
                    <div class="col-md mb-3">
                        <label class="form-label">Questionario di ingresso</label>
                        <select class="form-control" v-model="oCorso.cor_idQueInizio">
                            <option value="-1">Scegli questionario iniziale...</option>
                            <option v-for="q, i in ViewQuestIniziali()" :key="i" :value="q.que_idq">[{{ q.que_idq }}] {{ q.que_nome }}</option>
                        </select>
                    </div>

                    <div class="col-md mb-3">
                        <label class="form-label">Questionario di valutazione</label>
                        <select class="form-control" v-model="oCorso.cor_idQueFine">
                            <option value="-1">Scegli questionario finale...</option>
                            <option v-for="q, i in ViewQuestFinali()" :key="i" :value="q.que_idq">[{{ q.que_idq }}] {{ q.que_nome }}</option>
                        </select>
                    </div>
                </div>



                <template v-if="oCorso.cor_id > 0">
                    <div class="row rigaSezioneForm">
                        <div class="col-md">
                            <i class="fas fa-users text-primary"></i>&nbsp;Partecipanti
                        </div>
                    </div>

                    <!-- *** aggiunta partecipante *** -->
                    <div class="d-flex mb-2 mt-2 bg-edit p-2">
                        <div class="form-group me-2">
                            <label>Cliente</label>
                            <select class="form-select" v-model="idAnaSelParp" @change="GetListPersonale">
                                <option v-for="c, i in dtClienti" :key="i" :value="c.ana_id">{{c.ana_ragioneSociale}} [{{ c.ana_piva }}]</option>
                            </select>
                        </div>
                        
                        <div class="form-group me-2">
                            <label>Personale</label>
                            <select class="form-select" v-model="idPerSelParp">
                                <template v-for="p, i in dtPersonale" :key="i">
                                    <option v-if="p.per_eliminato == false" :value="p.per_id" >{{p.per_cognome}} {{ p.per_nome }} - {{ p.per_cf }}</option>
                                </template>
                                
                            </select>
                        </div>

                        <div class="form-group me-2">
                            <label style="color:transparent">.</label>
                            <button type="button" class="btn btn-success mt-4" @click="SalvaPartecipante"><i class="fas fa-plus" ></i>&nbsp;Aggiungi partecipante</button>
                            
                        </div>
                        

                    </div>

                    <!-- *** Bottoni griglia partecipanti *** -->
                    <div class="d-flex mb-2 mt-2">
                        <button type="button" class="btn btn-dark" @click="GetListPartecipanti"><i class="fas fa-sync"></i>&nbsp;</button>&nbsp;
                        <button type="button" class="btn btn-dark" @click="SelTuttiPartec"><i class="fas fa-check-square"></i>&nbsp;</button>&nbsp;
                        <button type="button" class="btn btn-dark" @click="DeSelTuttiPartec"><i class="fas fa-square"></i>&nbsp;</button>&nbsp;
                        <button type="button" class="btn btn-info" @click="GeneraAccessCode" :disabled="!persSelezionate"><i class="fas fa-lock-open"></i>&nbsp;Genera Access Code</button>&nbsp;
                        <button type="button" class="btn btn-primary" @click="InviaLink" :disabled="!persSelezionate"><i class="fas fa-paper-plane"></i>&nbsp;Invia link accesso</button>&nbsp;
                        <button type="button" class="btn btn-secondary" @click="EsportaPartecipanti"><i class="fas fa-file-excel"></i>&nbsp;Esporta partecipanti</button>&nbsp;
                        <button type="button" class="btn btn-secondary" @click="EsportaRegistro"><i class="fas fa-file-excel"></i>&nbsp;Esporta registro</button>&nbsp;
                    </div>


                    <!-- *** ELENCO PARTECIPANTI ***-->
                    <table class="table table-custom mb-4" style="overflow: visible;">
                        <thead>
                            <tr>
                                <th></th>
                                <th>Cognome</th>
                                <th>Nome</th>
                                <th>Cod. Fisc.</th>
                                <th>Email</th>
                                <th>Access Code</th>
                                <th>Azienda</th>
                                <th>Q. inizio</th>
                                <th>Q. fine</th>
                                <th>Stato registro</th>
                                <th>Attestato</th>
                                <th><i class="fas fa-bars"></i></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="p, i in dtPartecipanti" :key="i">
                                <td><input type="checkbox" @change="AreSelected" v-model="p.selected"></td>
                                <td>{{ p.per_cognome }}</td>
                                <td>{{ p.per_nome }}</td>
                                <td>{{ p.per_cf }}</td>
                                <td>{{ p.per_email }}</td>
                                <td>{{ p.per_accessCode }}</td>
                                <td>{{ p.ana_ragioneSociale }}</td>
                                <td>
                                    <span v-if="p.statoTestInizio == 0">--</span>
                                    <a href="#j" v-if="p.statoTestInizio == 1" @click="MostraRisultati(p, 1)"><i class="fas fa-check-circle text-success"></i></a>
                                    <a href="#j" v-if="p.statoTestInizio == 2" @click="MostraRisultati(p, 1)"><i class="fas fa-times-circle text-danger"></i></a>
                                </td>
                                <td>
                                    <span v-if="p.statoTestFine == 0">--</span>
                                    <a href="#j" v-if="p.statoTestFine == 1" @click="MostraRisultati(p, 2)"><i class="fas fa-check-circle text-success"></i></a>
                                    <a href="#j" v-if="p.statoTestFine == 2" @click="MostraRisultati(p, 2)"><i class="fas fa-times-circle text-danger"></i></a>
                                </td>
                                <td>
                                    <span v-if="p.statoRegistro == false">--</span>
                                    <span v-else><i class="fas fa-check-circle text-success"></i></span>
                                </td>
                                <!-- Attestato-->
                                <td>
                                    <a v-if="p.nrAttestato != '--'" href="#j" @click="ScaricaAttestato(p)">{{ p.nrAttestato }}</a>
                                    <span v-else>--</span>
                                </td>
                                <td>
                                    <div class="dropdown" >
                                        <a class="btn btn-outline-secondary dropdown-toggle" href="#" role="button" id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false">
                                            Azioni
                                        </a>

                                        <ul class="dropdown-menu" aria-labelledby="dropdownMenuLink" >
                                            <li><a class="dropdown-item" href="#j" @click="DelElemPartecipanti(p)"><i class="fas fa-trash fa-xs text-danger" title="Cancella"></i>&nbsp;Cancella</a></li>
                                            <li><hr class="dropdown-divider"></li>
                                            <li><a class="dropdown-item" target="_blank" :href="urlPortaleQuiz + '?email=' + p.per_email + '&accessCode=' + p.per_accessCode"><i class="fas fa-external-link-alt text-info"></i>&nbsp;Accedi portale quiz</a></li>
                                            <li><hr class="dropdown-divider"></li>
                                            <li v-if="p.nrAttestato == '--' & p.statoRegistro == true"><a class="dropdown-item" href="#j" @click="MostraDialogAttestato(p)"><i class="fas fa-file-word text-primary"></i>&nbsp;Crea attestato</a></li>

                                        </ul>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                        <tfoot>
                            <tr>
                                <td colspan="10">
                                    Totale partecipanti: {{ dtPartecipanti.length }}
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                    <small>NB. La creazione dell'attestato è visibile SOLO SE il registro è approvato dal docente in ogni giornata di corso.</small>
                    <br />
                    <br />
                    
                </template>

                

                              
                

                </form>
            </div>
            <div class="card-footer">
                <button type="button" class="btn btn-sm btn-outline-dark" @click="AttivaGriglia">Chiudi</button>&nbsp;
                <button type="button" class="btn btn-sm btn-outline-dark" @click="SalvaCorso(true)">Salva</button>&nbsp;
                <button type="button" class="btn btn-sm btn-outline-dark" @click="SalvaCorso(false)">Salva e Chiudi</button>
            </div>
            </div>

        </div>
    </div>


    <!-- *** DIALOG MOSTRA RISULTATI *** -->
    <dialog class="dialogMostraRisultati">
        <div class="d-flex mb-3" style="border-bottom:solid 1px #ccc" >
            <div class="">
                <i class="fas fa-poll text-primary"></i>
            </div>
            <div class="ms-2">
                <h5>Risultati per {{ oRisultati.nominativo }}</h5>
            </div>
        </div>

        <h5>{{ oRisultati.tipo }}</h5>

        <template v-for="q, iq in dtRisultati" :key="iq" >
            <div class="d-flex mb-3">
                Esito Test <span v-if="q.qrs_passed" class="text-success">&nbsp;SUPERATO&nbsp;</span> <span v-else class="text-danger">&nbsp;FALLITO&nbsp;</span> con un punteggio di {{ q.qrs_punteggio }} in data {{ FormattaDatetime(q.qrs_fine) }}
            </div>
            <ul style="list-style-type: none;">
                <li v-for="d, id in q.domande" :key="id" class="mb-4">
                    <em >{{ d.qdo_testo }}</em>
                    <ol class="mt-2">
                        <li v-for="r, ir in d.risposte" :key="ir" class="m-2">
                            <span v-if="r.rispostaData"><i class="fas fa-check" :class="{'text-success': r.rispostaData & r.qri_valore, 'text-danger': !(r.rispostaData & r.qri_valore)}"></i>&nbsp;</span>{{ r.qri_testo }} <strong v-if="r.qri_valore">*GIUSTA*</strong>
                        </li>
                    </ol>
                </li>
            </ul>

            <div class="d-flex mt-3">
                <button type="button" class="btn btn-danger me-2" @click="AnnullaRisultato(q.qrs_idrs)">Annulla questo risultato</button>
            </div>
            

        </template>

        <div class="d-flex justify-content-end">
            
            <button type="button" class="btn btn-outline-dark me-2" @click="ChiudiRisultati">Chiudi</button>
        </div>

    </dialog>


    <!-- *** DIALOG GENERA ATTESTATO *** -->
    <dialog class="dialogGeneraAttestato">
        <div class="d-flex mb-3" style="border-bottom:solid 1px #ccc" >
            <div class="">
                <i class="fas fa-graduation-cap text-primary"></i>
            </div>
            <div class="ms-2">
                <h5>Genera attestato per {{ oAttestato.nominativo }}</h5>
            </div>
        </div>

        <div class="row mb-2">
            <div class="col-md-2">
                Luogo
            </div>
            <div class="col-md-10">
                <input type="text" class="form-control" v-model="oAttestato.luogo" >
            </div>
        </div>
        <div class="row mb-2">
            <div class="col-md-2">
                Data
            </div>
            <div class="col-md-10">
                <input type="date" class="form-control" v-model="oAttestato.data" >
            </div>
        </div>
        

        <div class="d-flex justify-content-end">
            <button type="button" class="btn btn-outline-dark me-2" @click="ChiudiDialogAttestato">Chiudi</button>
            <button type="button" class="btn btn-primary me-2" @click="GeneraAttestato">Genera attestato</button>
        </div>

    </dialog>


    <iframe id="iFrameDn" name="iFrameDn" src="about:blank" style="display:none"></iframe> 
    
</template>

<script>
import GrigliaFacile from '@/components/GrigliaFacile.vue';
import snFunctions from '@/lib/snFunctions.js';
import ContentHeader from '@/components/layout/ContentHeader.vue';
import MessaggioStandard from '@/components/MessaggioStandard.vue';

export default {
    name: 'CorsiView',
    components: {
        ContentHeader, GrigliaFacile, MessaggioStandard
    },
    inject: ['cfg'],
    data: function() {
        return {
            urlPortaleQuiz: this.cfg.urlPortaleQuiz,
            dtCorsi: [],
            dtPartecipanti: [],
            dtClienti: [],
            dtCorsiStati: [],
            dtPersonale: [],
            dtQuestionari: [],
            dtDocenti: [],
            dtRisultati: [],

            //variabili per aggiunta partecipante
            idAnaSelParp: -1,
            idPerSelParp: -1,

            //Impostazioni griglia CORSI
            g_colonne: ['cor_id', 'cor_codice', 'vis_stato', 'vis_tipo', 'cor_dta_inizio', 'cor_dta_fine', 'npartecipanti', 'cor_npartecipanti_max', 'vis_docente', 'cor_titolo'],
            g_colonneHeader: ['Id', 'Cod.', 'St.', 'Tipo', 'Inizio', 'Fine', '# part.', '# posti', 'Docente', 'Titolo'],
            g_colonneNoOrder: ['vis_stato', 'vis_tipo', 'npartecipanti', 'cor_npartecipanti_max'], 
            g_colonneAlign: [
                {column: 'npartecipanti', align: 'text-center'}, 
                {column: 'cor_npartecipanti_max', align: 'text-center'}
            ],
            g_comandi: 
            [
                {titolo:'Cancella', icona:'fa-trash', iconaStile: 'btn btn-xs btn-outline-danger', emetti: 'Cancella'},
                // {titolo:'Valutazioni', icona:'fa-signal', iconaStile: 'btn btn-xs btn-outline-primary', emetti: 'Valutazioni'},
                // {titolo:'Duplica', icona:'fa-clone', iconaStile: 'btn btn-xs btn-outline-primary', emetti: 'Duplica'},
            ],
            g_queryLength: 0, //lunghezza della query (che NON è la lunghezza del dataset passato)
            g_currentPage: 1, //pagina corrente

            //Oggetto richiesta griglia
            reqGrigliaCorsi: {
                ele_pag: 10,
                start: 0,
                orderColumn: "cor_dta_inizio",
                orderDir:"DESC",
                token: this.$store.state.UserInfo.token,
                //Campi custom
                Testuale: "",
                
            },

            oCorso: {
                cor_id: -1,
                cor_idTipo: -1,
                cor_idCat: -1,
                cor_codice: "",
                cor_titolo: "",
                cor_descrizione: "",
                cor_dta_inizio: "",
                cor_dta_fine: "",
                cor_npartecipanti_min: 0,
                cor_npartecipanti_max: 0,
                cor_stato: 1,
                cor_idQueInizio: -1,
                cor_idQueFine: -1,
                cor_idDoc: -1,

                token: "",
            },

            oPartecipante: {
                cop_idCor:-1,
                cop_idPer:-1,
                token: "",
            },

            oRisultati: {
                tipo: "",
                nominativo: "",
                risultati: {}
            },

            oAttestato : {
                idAtt: -1,
                idCor: -1,
                idPer: -1,
                data: "",
                luogo: "",
                nominativo: "",
                statoTestInizio: 0,
                statoTestFine: 0,
                
            },
         
            persSelezionate: false,

            mostraGrigliaCorsi: true,
            mostraEditCorso: false,

            mostraMessaggio: false,
            alertMessaggio: "",
            alertClass: "",     
            alertIcon: "",
            alertIconSpin: false
           
        
        }
    },
    methods: {
        // GESTIONE PANNELLI E PULIZIA INPUT
        AttivaGriglia() {
            this.mostraEditCorso = false;
            this.mostraGrigliaCorsi = true;

            this.GetListCorsi();
        },
        AzzeraFiltri() {
            this.reqGrigliaCorsi.Testuale = "";
            this.GetListCorsi();
        },
        AttivaEditCorso() {
            this.mostraEditCorso = true;
            this.mostraGrigliaCorsi = false;
            
            this.ClearMessaggio();
            this.ClearCorso();

        },
        ClearCorso() {
            this.oCorso = {
                cor_id: -1,
                cor_idTipo: -1,
                cor_idCat: -1,
                cor_codice: "",
                cor_titolo: "",
                cor_descrizione: "",
                cor_dta_inizio: "",
                cor_dta_fine: "",
                cor_npartecipanti_min: 0,
                cor_npartecipanti_max: 0,
                cor_stato: 1,
                cor_idQueInizio: -1,
                cor_idQueFine: -1,
                cor_idDoc: -1,
                                
                token: "",
            }
        },
        ClearMessaggio() {
            this.mostraMessaggio = false;
            this.alertMessaggio =  "";
            this.alertClass = "";
            this.alertIcon = "";
            this.alertIconSpin = false;
        },
        
        // *** OPERAZIONI DI BASE SU CORSI
        GetListCorsi() {
            //Carica lista elementi
            this.$store.commit('Messaggio', {parms: [true, ['Caricamento griglia in corso...'], 'alert alert-info', 'fa-spinner', true, 0]});
            fetch(this.cfg.apisrv + "/api/Corsi/GetListCorsi" , {
                "method": "POST",
                "headers": {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                "body": JSON.stringify(this.reqGrigliaCorsi)
            }).then(response => response.json())
                .then(obj => {
                    if(obj.status == "OK") {
                        this.$store.commit('Messaggio', {parms: [true, ['Griglia caricata.'], 'alert alert-success', 'fa-check', false, 2000]});
                
                        for(let i = 0; i<obj.moreJsonData.length; i++){
                            //Formatta stato
                            if(obj.moreJsonData[i].cor_stato == 1) {
                                obj.moreJsonData[i].vis_stato = "<div class='div-pill div-pill-info'>" + obj.moreJsonData[i].cst_descrizione + "</div>";
                            }
                            else if(obj.moreJsonData[i].cor_stato == 2) {
                                obj.moreJsonData[i].vis_stato = "<div class='div-pill div-pill-green'>" + obj.moreJsonData[i].cst_descrizione + "</div>";
                            }
                            else if(obj.moreJsonData[i].cor_stato == 3) {
                                obj.moreJsonData[i].vis_stato = "<div class='div-pill div-pill-dark'>" + obj.moreJsonData[i].cst_descrizione + "</div>";
                            }

                            //Formatta il tipo
                            if(obj.moreJsonData[i].cor_idTipo == 1) {
                                obj.moreJsonData[i].vis_tipo = "<i class='fas fa-certificate fa-sm fa-fw text-danger'></i>&nbsp;" + obj.moreJsonData[i].cot_descrizione + "</div>";
                            } else { 
                                obj.moreJsonData[i].vis_tipo = "<i class='fas fa-handshake fa-sm fa-fw text-info'></i>&nbsp;" + obj.moreJsonData[i].cot_descrizione + "</div>";
                                //obj.moreJsonData[i].vis_tipo = obj.moreJsonData[i].cot_descrizione; 
                            }

                            //Docente
                            obj.moreJsonData[i].vis_docente = obj.moreJsonData[i].doc_cognome + ' ' + obj.moreJsonData[i].doc_nome;
                        }

                        


                        this.dtCorsi = obj.moreJsonData;
                        this.g_queryLength = parseInt(obj.dati[0], 10);
                    } else {
                        this.$store.commit('Messaggio', {parms: [true, ['Errore caricamento griglia.'], 'alert alert-danger', 'fa-times', false, 2000]});
                    }
                });
        },
        GetElemCorsi(idelem) {
            //Carica elemento singolo
            this.ClearMessaggio();
            fetch(this.cfg.apisrv + "/api/Corsi/GetElemCorsi?token=" + this.$store.state.UserInfo.token + "&idCor=" + idelem)
            .then(response => response.json())
            .then(obj => {

                this.oCorso = obj;

                this.mostraGrigliaCorsi=false;
                this.mostraEditCorso= true;

                this.$store.commit('Messaggio', {parms: [true, ['Corso caricato.'], 'alert alert-success', 'fa-check', false, 2000]});

                this.GetListPartecipanti();

            });
        },
        //Esporta su Excel
        EsportaListaCorsi() {
            let qy = "?token=" + this.$store.state.UserInfo.token + 
                    "&orderColumn=" + this.reqGrigliaCorsi.orderColumn + "&orderDir=" + this.reqGrigliaCorsi.orderDir +
                    "&Testuale=" + this.reqGrigliaCorsi.Testuale;
            let url =this.cfg.apisrv + "/api/Corsi/EsportaListaCorsi" + qy;
            let iFrameDn = document.getElementById("iFrameDn");
            iFrameDn.src = url;
          
        },
        //modifica corso 
        SelectCorso(o)  {
            this.GetElemCorsi(o.cor_id);
        },

        SalvaCorso(reload) {
            let oSubmit = [];
            oSubmit = this.oCorso;
            oSubmit.token = this.$store.state.UserInfo.token;
                  
            this.ClearMessaggio();
            this.$store.commit('Messaggio', {parms: [true, ['Salvataggio in corso...'], 'alert alert-info', 'fa-spinner', true, 0]});
            fetch(this.cfg.apisrv + "/api/Corsi/SalvaCorso", {
                "method": "POST",
                "headers": {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                "body": JSON.stringify(oSubmit)
            }).then(response => response.json())
                .then(obj => {
                    if (obj.status == "OK") {
                        this.$store.commit('Messaggio', {parms: [true, ['Salvataggio effettuato.'], 'alert alert-success', 'fa-check', false, 2000]});
                        if(reload)  {
                            this.GetElemCorsi(obj.dati[0]);
                        }
                        else {
                            //Fa redirect
                            this.AttivaGriglia();
                        }
                    }
                    else {
                        this.$store.commit('Messaggio', {parms: [true, ["Sono presenti errori di compilazione"], 'alert alert-warning', 'fa-times', false, 3000]});

                        this.mostraMessaggio = true;
                        this.alertMessaggio = obj.dati;
                        this.alertClass = "alert alert-warning";
                        this.alertIcon = "fa-xmark"
                        this.alertIconSpin = false
                    }
                });

        },

        DelElemCorsi(e) {
            //Cancella elemento singolo
            if(confirm("Cancellare l'elemento?")) {
                fetch(this.cfg.apisrv + "/api/Corsi/DelElemCorsi?token=" + this.$store.state.UserInfo.token + "&idCor=" + e.cor_id)
                .then(response => response.json())
                .then(obj => {
                    if(obj.status == "OK") {
                        this.$store.commit('Messaggio', {parms: [true, ['Eliminato'], 'alert alert-success', 'fa-check', false, 2000]});
                        this.GetListCorsi(); 
                    } else {
                        this.$store.commit('Messaggio', {parms: [true, [obj.errorMessage], 'alert alert-danger', 'fa-times', false, 2000]});
                    }
                    
                });
            }

        },


        // *** OPERAZIONI DI BASE SUI PARTECIPANTI
        GetListPartecipanti() {
            //Carica lista elementi
            fetch(this.cfg.apisrv + "/api/Partecipanti/GetListPartecipanti?token=" + this.$store.state.UserInfo.token + "&idCor=" + this.oCorso.cor_id)
                .then(response => response.json())
                .then(obj => {
                    this.dtPartecipanti = obj;
                });
        },
        SalvaPartecipante() {
            let oSubmit = [];
            oSubmit = this.oPartecipante;
            oSubmit.cop_idCor = this.oCorso.cor_id;
            oSubmit.cop_idPer = this.idPerSelParp;
            oSubmit.token = this.$store.state.UserInfo.token;

            if(oSubmit.cop_idCor >=0 && oSubmit.cop_idPer >= 0) {

                //this.ClearMessaggio();
                this.$store.commit('Messaggio', {parms: [true, ['Salvataggio in corso...'], 'alert alert-info', 'fa-spinner', true, 0]});
                fetch(this.cfg.apisrv + "/api/Partecipanti/SalvaPartecipanti", {
                    "method": "POST",
                    "headers": {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    "body": JSON.stringify(oSubmit)
                }).then(response => response.json())
                    .then(obj => {
                        if (obj.status == "OK") {
                            this.$store.commit('Messaggio', {parms: [true, ['Salvataggio effettuato.'], 'alert alert-success', 'fa-check', false, 2000]});
                        
                            this.GetListPartecipanti();
                        }
                        else {
                            this.$store.commit('Messaggio', {parms: [true, ["Sono presenti errori di compilazione"], 'alert alert-warning', 'fa-times', false, 3000]});

                            // this.mostraMessaggio = true;
                            // this.alertMessaggio = obj.dati;
                            // this.alertClass = "alert alert-warning";
                            // this.alertIcon = "fa-xmark"
                            // this.alertIconSpin = false
                        }
                    });
            } //endif
        },
        DelElemPartecipanti(e) {
            //Cancella elemento singolo
            if(confirm("Cancellare l'elemento?")) {
                fetch(this.cfg.apisrv + "/api/Partecipanti/DelElemPartecipanti?token=" + this.$store.state.UserInfo.token + "&idPer=" + e.per_id + "&idCor=" + e.cor_id)
                .then(response => response.json())
                .then(obj => {
                    if(obj.status == "OK") {
                        this.$store.commit('Messaggio', {parms: [true, ['Eliminato'], 'alert alert-success', 'fa-check', false, 2000]});
                        this.GetListPartecipanti(); 
                    } else {
                        this.$store.commit('Messaggio', {parms: [true, [obj.errorMessage], 'alert alert-danger', 'fa-times', false, 2000]});
                    }
                    
                });
            }

        },
        SelTuttiPartec() {
            this.dtPartecipanti.forEach(e => {
                e.selected = true;
            });
            this.AreSelected()
        },
        DeSelTuttiPartec() {
            this.dtPartecipanti.forEach(e => {
                e.selected = false;
            });
            this.AreSelected()
        },
        GeneraAccessCode() {
            let aSel =  [];
            this.dtPartecipanti.forEach(e => {
                if(e.selected) aSel.push(e.per_id);
            });

            if(confirm("Vuoi generare/rigenerare i codici di accesso?")) {
                fetch(this.cfg.apisrv + "/api/Personale/GeneraAccessCode?token=" + this.$store.state.UserInfo.token + "&ids=" + aSel.toString())
                .then(response => response.json())
                .then(obj => {
                    if(obj.status == "OK") {
                        this.$store.commit('Messaggio', {parms: [true, ['Access code generato'], 'alert alert-success', 'fa-check', false, 2000]});
                        this.GetListPartecipanti(); 
                        this.DeSelTuttiPartec();
                    } else {
                        this.$store.commit('Messaggio', {parms: [true, [obj.errorMessage], 'alert alert-danger', 'fa-times', false, 2000]});
                    }
                    
                });
            }
        },
        InviaLink() {
            let aSel =  [];
            this.dtPartecipanti.forEach(e => {
                if(e.selected) aSel.push(e.per_id);
            });

            if(confirm("Vuoi inviare il codice di accesso ai partecipanti selezionati?")) {
                fetch(this.cfg.apisrv + "/api/Personale/InviaLink?token=" + this.$store.state.UserInfo.token + "&ids=" + aSel.toString())
                .then(response => response.json())
                .then(obj => {
                    if(obj.status == "OK") {
                        this.$store.commit('Messaggio', {parms: [true, ['Link inviato'], 'alert alert-success', 'fa-check', false, 2000]});
                        this.GetListPartecipanti(); 
                        this.DeSelTuttiPartec();
                    } else {
                        this.$store.commit('Messaggio', {parms: [true, [obj.errorMessage], 'alert alert-danger', 'fa-times', false, 2000]});
                    }
                    
                });
            }
        },


        // ****** ESPORTAZIONI *******

        //Esporta partecipanti su Excel
        EsportaPartecipanti() {
            let qy = "?token=" + this.$store.state.UserInfo.token + 
                    "&idCor=" + this.oCorso.cor_id;
            let url =this.cfg.apisrv + "/api/Corsi/EsportaPartecipanti" + qy;
            let iFrameDn = document.getElementById("iFrameDn");
            iFrameDn.src = url;
          
        },

        //Esporta registro su Excel
        EsportaRegistro() {
            let qy = "?token=" + this.$store.state.UserInfo.token + 
                    "&idCor=" + this.oCorso.cor_id;
            let url =this.cfg.apisrv + "/api/Corsi/EsportaRegistro" + qy;
            let iFrameDn = document.getElementById("iFrameDn");
            iFrameDn.src = url;
          
        },

        // ***** ATTESTATI ******

        MostraDialogAttestato(o) {
            this.oAttestato.idPer = o.per_id;
            this.oAttestato.idCor = o.cor_id;
            this.oAttestato.nominativo = o.per_nome + " " + o.per_cognome;
            this.oAttestato.statoTestInizio = o.statoTestInizio;
            this.oAttestato.statoTestFine = o.statoTestFine;

            const dialog = document.querySelector(".dialogGeneraAttestato");
            dialog.showModal();


        },

        GeneraAttestato() {
            if(this.oAttestato.data != '' && this.oAttestato.luogo != '') {
                if(confirm("Vuoi generare l'attestato")) {
                    let dataInserita = new Date(this.oAttestato.data);
                    let dataOggi = new Date();

                    dataOggi.setHours(0,0,0,0);
                    dataInserita.setHours(0,0,0,0);

                    if(dataInserita > dataOggi) {
                        alert("Non è possible specificare una data successiva a quella odierna.");
                    }
                    else {
                        let qy = "?token=" + this.$store.state.UserInfo.token + 
                        "&idCor=" + this.oAttestato.idCor +
                        "&idPer=" + this.oAttestato.idPer +
                        "&data=" + this.oAttestato.data +
                        "&luogo=" + this.oAttestato.luogo +
                        "&statoTestInizio=" + this.oAttestato.statoTestInizio + 
                        "&statoTestFine=" + this.oAttestato.statoTestFine;
                        let url =this.cfg.apisrv + "/api/Corsi/GeneraAttestato" + qy;
                        let iFrameDn = document.getElementById("iFrameDn");
                        iFrameDn.src = url;

                        window.setTimeout(()=> {
                            this.GetListPartecipanti();
                        }, 2000);

                        const dialog = document.querySelector(".dialogGeneraAttestato");
                        dialog.close();
                    }

                    

                }
            }
            
        },

        ScaricaAttestato(o) {
            let qy = "?token=" + this.$store.state.UserInfo.token + 
                    "&idAtt=" + o.idAtt;                    
                    let url =this.cfg.apisrv + "/api/Corsi/RiGeneraAttestato" + qy;
                    let iFrameDn = document.getElementById("iFrameDn");
                    iFrameDn.src = url;
        },

        ChiudiDialogAttestato(o) {
            const dialog = document.querySelector(".dialogGeneraAttestato");
            dialog.close();

        },



        // ***** RISULTATI *****

        MostraRisultati(p, tipo) {
            const dialog = document.querySelector(".dialogMostraRisultati");
            dialog.showModal();

            let idQue = -1;
            if(tipo == 1) { this.oRisultati.tipo = "Valutazione ingresso"; idQue = p.cor_idQueInizio; } 
            if(tipo == 2) {this.oRisultati.tipo = "Valutazione finale"; idQue = p.cor_idQueFine; }
            this.oRisultati.nominativo = p.per_cognome + ' ' + p.per_nome;
            //this.oRisultati.

            //recupera risultati
            fetch(this.cfg.apisrv + "/api/QuestionariRisultati/RisultatiUtente?token=" + this.$store.state.UserInfo.token + "&idusr=" + p.per_email + "&idQue=" + idQue + "&idCor=" + this.oCorso.cor_id )
                .then(response => response.json())
                .then(obj => {
                    this.dtRisultati = obj;
                });


        },
        ChiudiRisultati() {
            const dialog = document.querySelector(".dialogMostraRisultati");
            dialog.close();
        },
        AnnullaRisultato(idrs) {
           
            if(confirm("Sei sicuro di voler annullare l'esito di questo quiz?")) {
                fetch(this.cfg.apisrv + "/api/QuestionariRisultati/AnnullaRisultato?token=" + this.$store.state.UserInfo.token + "&idrs=" + idrs)
                    .then(response => response.json())
                    .then(obj => {
                        if(obj.status == "OK") {
                            this.$store.commit('Messaggio', {parms: [true, ['Risultato cancellato'], 'alert alert-success', 'fa-check', false, 2000]});
                            this.GetListPartecipanti(); 
                            this.DeSelTuttiPartec();
                        } else {
                            this.$store.commit('Messaggio', {parms: [true, [obj.errorMessage], 'alert alert-danger', 'fa-times', false, 2000]});
                        }
                       
                    });
            }


        },



        // *** CARICAMENTO TABELLE SERVIZIO
        GetListClienti() {
            //Carica lista elementi
            fetch(this.cfg.apisrv + "/api/AnagraficaClienti/GetListAnagraficaClienti?token=" + this.$store.state.UserInfo.token + "&full=no")
                .then(response => response.json())
                .then(obj => {
                    this.dtClienti = obj;
                });
        },
        GetListCorsiStati() {
            //Carica lista elementi
            fetch(this.cfg.apisrv + "/api/CorsiStati/GetListCorsiStati?token=" + this.$store.state.UserInfo.token)
                .then(response => response.json())
                .then(obj => {
                    this.dtCorsiStati = obj;
                });
        },
        GetListPersonale() {
            //Carica lista elementi
            fetch(this.cfg.apisrv + "/api/Personale/GetListPersonale?token=" + this.$store.state.UserInfo.token + "&idAna=" + this.idAnaSelParp)
                .then(response => response.json())
                .then(obj => {
                    this.dtPersonale = obj;
                    this.AreSelected();
                });
        },
        GetListQuestionari() {
            //Carica lista elementi
            fetch(this.cfg.apisrv + "/api/Questionari/GetListQuestionari?token=" + this.$store.state.UserInfo.token)
                .then(response => response.json())
                .then(obj => {
                    this.dtQuestionari = obj;
                });
        },
        GetListDocenti() {
            //Carica lista elementi
            fetch(this.cfg.apisrv + "/api/Docenti/GetListDocenti?token=" + this.$store.state.UserInfo.token)
                .then(response => response.json())
                .then(obj => {
                    this.dtDocenti = obj;
                });
        },

        //****** VIEWS e FILTRI ***** */
        ViewQuestIniziali() {
            return this.dtQuestionari.filter((p) => p.que_tipo == 1 );
        },

        ViewQuestFinali() {
            return this.dtQuestionari.filter((p) => p.que_tipo == 2 );
        },

        AreSelected() {
            let sel = false;

            this.dtPartecipanti.forEach(element => {
                
                if(element.selected) sel = true;
            });
            console.log(sel)
            this.persSelezionate = sel;
        },

        
    

        //PAGINAZIONE GRIGLIA
        CambiaElementi(nrElem) {
            this.reqGrigliaCorsi.ele_pag = nrElem;
            this.GetListCorsi();
        },
        PaginaPrecendente() {
            this.reqGrigliaCorsi.start = this.reqGrigliaCorsi.start - parseInt(this.reqGrigliaCorsi.ele_pag, 10);
            this.g_currentPage--;
            this.GetListCorsi();  
        
        },
        PaginaSuccessiva() {
            this.reqGrigliaCorsi.start = this.reqGrigliaCorsi.start + parseInt(this.reqGrigliaCorsi.ele_pag, 10);
            this.g_currentPage++;
            this.GetListCorsi();
        
        },
        CambiaPagina(pag) {
            this.reqGrigliaCorsi.start = (parseInt(this.reqGrigliaCorsi.ele_pag, 10) * pag) - parseInt(this.reqGrigliaCorsi.ele_pag, 10);
            this.g_currentPage = pag;
            this.GetListCorsi();
        },

        // ORDINA LA GRIGLIA
        OrdinaGriglia(i) {
            if(this.reqGrigliaCorsi.orderColumn == this.g_colonne[i]) {
                //Stessa colonna
                if(this.reqGrigliaCorsi.orderDir == 'DESC') {this.reqGrigliaCorsi.orderDir = 'ASC';}
                else {this.reqGrigliaCorsi.orderDir = 'DESC';}
            }
            else {
                //altra colonna
                this.reqGrigliaCorsi.orderColumn = this.g_colonne[i];
                this.reqGrigliaCorsi.orderDir = 'DESC';
                
            }
            
            this.GetListCorsi();

        },

        //HELPER VARI
        FormattaDatetime(dta) {
            return snFunctions.dateFormat(dta, "dd-MM-yyyy");
        }
    
    },
    computed: {
        
    },
    mounted: function() {
        if(this.$store.state.UserInfo.token == '') this.$router.push("/");

        this.GetListCorsi();
        this.GetListClienti();
        this.GetListCorsiStati();
        this.GetListQuestionari();
        this.GetListDocenti();

        if(this.$route.query.edit != null && this.$route.query.edit != '' ) {
            this.GetElemCorsi(this.$route.query.edit);
        }

             

    }
}
</script>